module.exports = __webpack_public_path__ + "img/menorah.bf206c96.png";